import { render, staticRenderFns } from "./CleaningsTable.vue?vue&type=template&id=22c4b360"
import script from "./CleaningsTable.vue?vue&type=script&lang=js"
export * from "./CleaningsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports